import { render, staticRenderFns } from "./RenameShortlist.vue?vue&type=template&id=68bcc10c&"
import script from "./RenameShortlist.vue?vue&type=script&lang=js&"
export * from "./RenameShortlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports